import { render, staticRenderFns } from "./ListPosts.vue?vue&type=template&id=c5292498&scoped=true"
import script from "./ListPosts.vue?vue&type=script&lang=js"
export * from "./ListPosts.vue?vue&type=script&lang=js"
import style0 from "./ListPosts.vue?vue&type=style&index=0&id=c5292498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5292498",
  null
  
)

export default component.exports